import { logger } from 'monitor';

import { MaterialProductComponentValue, MaterialProductValueType, SiteMaterialDetail } from '../../schemas';
import { getUnitOfMeasureLabel } from '../unitOfMeasure/unitOfMeasure';

const getMaterialProductValueTypeDisplayedName = (type: MaterialProductValueType): string => {
  switch (type) {
    case MaterialProductValueType.BUYER:
      return 'Buyer';
    case MaterialProductValueType.SELLER:
      return 'Seller';
    default:
      return 'Unknown';
  }
};

export const getInternalMaterialProductComponentLabel = (
  materialProductComponentValue: MaterialProductComponentValue
) => {
  const unit = getUnitOfMeasureLabel(materialProductComponentValue.supported_component.component.unit || '');
  if (materialProductComponentValue.min_value && materialProductComponentValue.max_value) {
    return `${materialProductComponentValue.supported_component.component.name} ${materialProductComponentValue.min_value}${unit} - ${materialProductComponentValue.max_value}${unit}`;
  }
  if (materialProductComponentValue.min_value) {
    return `${materialProductComponentValue.supported_component.component.name} min: ${materialProductComponentValue.min_value}${unit}`;
  }
  if (materialProductComponentValue.max_value) {
    return `${materialProductComponentValue.supported_component.component.name} max: ${materialProductComponentValue.max_value}${unit}`;
  }
};

const getInternalMaterialProductComponentValueListLabel = (
  materialComponents: MaterialProductComponentValue[],
  MaterialProductValueType: MaterialProductValueType
): string => {
  const materialProductValuesDisplayedName = materialComponents
    .filter((materialComponent) => materialComponent.type === MaterialProductValueType)
    .map((materialComponent) => getInternalMaterialProductComponentLabel(materialComponent))
    .join(', ');
  return `${getMaterialProductValueTypeDisplayedName(MaterialProductValueType)} ${materialProductValuesDisplayedName}`;
};

export const getInternalFullMaterialProductComponentListLabel = (
  materialComponents: MaterialProductComponentValue[]
): string => {
  const buyerMaterialComponentValuesDisplayedName = getInternalMaterialProductComponentValueListLabel(
    materialComponents,
    MaterialProductValueType.BUYER
  );
  const sellerComponentValuesDisplayedName = getInternalMaterialProductComponentValueListLabel(
    materialComponents,
    MaterialProductValueType.SELLER
  );
  return [sellerComponentValuesDisplayedName, buyerMaterialComponentValuesDisplayedName].filter(Boolean).join(' - ');
};

export type SampleVariant = 'zorba' | 'alu' | 'pet' | 'petFlake' | 'taintTabor';

export const getSampleVariantFromMaterial = (
  material?: SiteMaterialDetail['material_spec']['title']
): SampleVariant | undefined => {
  if (!material) {
    return undefined;
  }

  if (material?.includes('PET Flake') || material?.includes('PET Bottles Flake')) {
    return 'petFlake';
  }

  if (material.includes('Aluminium Zorba')) {
    return 'zorba';
  }

  if (material.includes('Aluminium Taint Tabor')) {
    return 'taintTabor';
  }
  if (material.includes('Aluminium Cans')) {
    return 'alu';
  }
  if (material.includes('PET Bottles')) {
    return 'pet';
  }

  logger.error('Sample material not found', { material });
  return undefined;
};
